// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"29737a9e","423":"228814a5","854":"dac44ec5"}[chunkId] + ".chunk.js";
};